const Index = () => import('../index.vue');
const SignUp = () => import('@/modules/SignUp/components/SignUp.vue');
const Verify = () => import('@/modules/SignUp/components/Verify.vue');

export default [
  {
    path: '/signup',
    component: Index,
    title: 'Sign Up',
    children: [
      // {
      //   path: 'location',
      //   name: 'authentication-find-location',
      //   component: FindLocation,
      //   props: true,
      // },
      {
        path: '/',
        name: 'create-new-account',
        component: SignUp,
        props: true,
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`) == null) {
        //     console.log('No location code was found', to); // eslint-disable-line
        //     let url = '/login/location';
        //     if (to.query && to.query.code) url = `${url}/?`;
        //     next({
        //       path: url,
        //       params: { nextUrl: to.fullPath },
        //       query: { ...to.params },
        //     });
        //   } else {
        //     console.log('just next?')
        //     next();
        //   }
        // },
      },
			{
				path: '/verify',
				name: 'verify',
				component: Verify,
				title: 'Verify',
				children: [],
			},
    ],
  },
];
